import TopBar from '../topBar/TopBar';
import RaptorSnackbar from '../../feedback/raptorSnackbar/Snackbar.component';
import ControlBar from '../controlBar/ControlBar.component';
import { useSelector } from 'react-redux';
import { isControlBarShowingSelector } from '../../../redux/ui/controlbar/selectors';
import { RaidrKidsProvider } from '../../pages/raidr/kids/context/RaidrKidsContext';
import { Outlet } from 'react-router-dom';
import AuthenticatedPage from '../../../routes/utils/AuthenticatedPage';

const RAIDRLayout = () => {
  const controlBarIsShowing = useSelector(isControlBarShowingSelector);

  return (
    <RaidrKidsProvider>
      <main className="flex flex-col overflow-auto bg-background">
        <TopBar />
        {controlBarIsShowing && <ControlBar />}
        <main className="flex h-[calc(100%-3.75rem)]">
          <div className="w-full p-2.5">
            <AuthenticatedPage Component={Outlet} hardSection="raidr" />
          </div>
        </main>
        <RaptorSnackbar />
      </main>
    </RaidrKidsProvider>
  );
};
export default RAIDRLayout;
